import { cn } from "@EspaceParkQC/sdk-react";

export default function Wrapper({ children, className }: { children: React.ReactNode; className?: string }): React.ReactElement {
  return <div className={cn("flex flex-col min-h-screen", className)}>{children}</div>;
}
